module.exports = __webpack_public_path__ + "static/media/illustration-lideranca.90ae4f98.svg";